import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import ptPT from "./locales/pt-PT.json";
import ptBR from "./locales/pt-BR.json";
import en from "./locales/en.json";
import fr from "./locales/fr.json";
import es from "./locales/es.json";
import it from "./locales/it.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      "pt-PT": { translation: ptPT },
      "pt-BR": { translation: ptBR },
      en: { translation: en },
      fr: { translation: fr },
      es: { translation: es },
      it: { translation: it },
    },
    fallbackLng: "pt-PT",
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "i18nextLng",
      convertDetectedLanguage: (lng: string) => {
        // Map pt to pt-PT, pt-BR stays
        if (lng === "pt" || lng === "pt-PT") return "pt-PT";
        if (lng === "pt-BR") return "pt-BR";
        // Map en-US, en-GB etc. to en
        const base = lng.split("-")[0];
        if (["en", "fr", "es", "it"].includes(base)) return base;
        return lng;
      },
    },
  });

export default i18n;
